import React from "react";
import PageBody from "../../components/pagebody/PageBody";
import Heading from "../../components/heading/Heading";
import { HEADING } from "../../components/heading/constants/constants";
import TextInput from "../../components/input/textinput/TextInput";
import Label from "../../components/label/Label";
import { LABEL_WEIGHT } from "../../components/label/constants";
import SelectDropdown from "../../components/dropdown/selectdropdown/SelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setExportFile, setInsights, setRowsPerPage, setSelectedForm, setSelectedStatus, setSelectedYear, setShowTestAccountWarningModal, setSkip, setTin, setTypeReference } from "./HomeSectionSlice";
import Button from "../../components/button/Button";
import styles from './HomeSection.styles'
import RichGrid from "../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../components/richgrid/constants";
import { useEffect } from "react";
import { componentKey as authenticationComponentKey } from "../authentication/AuthenticationSlice";
import { componentKey as dataLoaderComponentKey } from "../../businesslogic/loaders/dataloader/DataLoaderSlice";
import { checkIsNewUser, createPDF, getAccountStatus, getDashboardExcelData, getFilterData, getReportData } from "./HomeSectionSaga";
import { BUTTON_TYPE } from "../../components/button/constants";
import DateUtils from "../../../libs/utility/DateUtils";
import Popup from "../../components/popup/Popup";
import { useState } from "react";
import RadioInput from "../../components/input/radioinput/RadioInput";
import Loadable from "../../components/loadable/Loadable";
import useGarbageCollector from "../../../libs/garbagecollector/garbageCollectorHooks";
import Icons from "../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../components/icons/constants";
import ChangePlan from "../components/changeplan/ChangePlan";
import HorizontalSeparator from "../../components/separator/horizontalSeparator/HorizontalSeparator";
import { FORM_SECTION_ROUTES, QUERY_PARAMS_VALUE } from "../formssection/constants";
import VerticalSeparator from "../../components/separator/verticalseparator/VerticalSeparator";
import { ShowForAllowedPermissionsOnly } from "../wrappers/ShowForAllowedPermissionsOnly";
import { PAGE_PERMISSIONS } from "../dashboard/constants/constant";
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, FORM_TYPE, MANAGE_BOI_ROUTES, PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from "../constants/constants";
import General from "../../../libs/utility/General";
import { USER_PLAN_NAME, USER_TYPE_MAPPING } from "../../../libs/customhooks/constants";
import CheckboxWLabel from "../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import { componentKey as dashboardComponentKey } from "../dashboard/DashboardSlice";
import useTxNavigate from "../../../libs/txnavigate/TxNavigateHook";
import TxTooltip from "../../components/tooltip/TxTooltip";
import { INSIGHT_ITEMS, getInsightIcon, getInsightsMessage } from "./helperfuncitons/HelperFunction";
import MiniCTACarousel from "./components/carousel/MiniCTACarousel";
import { FEATURE_FLAG } from "../../featureFlags";
import axios from "axios";
import InformationPopup from "../../components/popup/informationpopup/InformationPopup";
import { Link } from "react-router-dom";
import { APP_PRODUCTION_URL } from "../dashboard/constants";
import useDelayedAction from "../../../libs/customhooks/useDelayedAction";
import { BOI_QUERY_PARAMS } from "../boireportingsection/constants";

export default function HomeSection() {
	useGarbageCollector(componentKey)

	const { 
		loadingState, 
		exportFile, 
		skip, 
		isNewUserLoading, 
		rowsPerPage, selectedStatus, 
		statusList, 
		formList, 
		yearList, 
		reportData, 
		selectedYear, 
		selectedForm, 
		tin, 
		typeReference, 
		totalReport, 
		isNewUser,
		insights, 
		urgentIssues,
		showTestAccountWarningModal,
	} = useSelector((state) => state[componentKey])

	const { isUserAuthenticated, signedInUser } = useSelector((state) => state[authenticationComponentKey])
	const { IsTinUnmaskAllowed } = useSelector(state =>state[dashboardComponentKey])
	const { forms94xList, formCategory, backEndConfigSettings } = useSelector((state) => state[dataLoaderComponentKey])
	const dispatch = useDispatch();
	const [showPopup, setShowPopup] = useState(false);
	const [showChangePlanPopup, setShowChangePlanPopup] = useState(false);
	const [selectedRow, setSelectedRow] = useState();
	const [maskTin, setMaskTin] = useState(false)
	const navigate = useTxNavigate();
	const [showGreetingHeader, setShowGreetingHeader] = useState(true);
	const [mergeCopies, setMergeCopies] = useState(false);
	
	const COPY_OPTIONS = [
		{ label: 'All Copies', value: 'all' },
		{ label: 'Recipient Copy', value: 'payee' },
		{ label: 'Payer Copy', value: 'payer' },
		...(IsTinUnmaskAllowed ? [{ label: 'View TIN', isCheckBox: true, isChecked: maskTin, onChangeCb: (val) => setMaskTin(val) }] : []),
		{ label: 'Merge Copies', isCheckBox: true, isChecked: mergeCopies, onChangeCb: (val) => setMergeCopies(val) },
	].filter(option => {
		if (signedInUser?.PlanName === USER_PLAN_NAME.ESSENTIAL_USER && option.value === 'payer') {
		} else {
			return option
		}

	})

	const FILE_STATUS = {
		BLOCKED: "Blocked",
		IRS_ACCEPTED: "IRS Accepted",
		INQUEUE: "InQueue",
		NOT_SUBMITTED: "Not submitted",
		ONLYSTATESUBMITTED: "OnlyStateSubmitted",
		RESUBMITTED_FOR_REVIEW: "ReSubmitted For Review",
		RESUBMIT: "Resubmit",
		REVIEW_APPROVED: "Review Approved",
		REVIEW_REJECTED: "Review Rejected",
		SUBMITTED: "Submitted",
		SUBMITTED_FOR_REVIEW: "Submitted for Review"
	}

	const [selectedCopy, setSelectedCopy] = useState(COPY_OPTIONS.find(option => option.value === 'payer' || option.value === 'payee') || COPY_OPTIONS[0])

	const getFileStatus = (row) => {
		return statusList?.find(status => status.value !== null && status.value.includes(row.StatusId))?.label ?? ""
	}

	const DASHBOARD_COLUMNS = [
		{
			field: "date",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Date</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{DateUtils.dateFormatter(row.Date, "MM/DD/YYYY")}</span>
		},
		{
			field: "tin",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>TIN</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{(row?.TIN && row.TIN !== "") ? `XX XXX${row.TIN}`: '-'}</span>  
		},
		{
			field: "referenceId",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Reference ID</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.ReferenceId}</span>
		},
		{
			field: "status",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Status</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{getFileStatus(row)}</span>
		},
		{
			field: "name",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Name</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.Name}</span>
		},
		{
			field: "formType",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Form Type</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.FormType}</span>
		},
		{
			field: "isCorrected",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Is Corrected</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.IsCorrected.toString()}</span>
		},
		{
			field: "formCount",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Form Count</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.FormCount}</span>
		},
		{
			field: "scheduleDate",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Schedule Date</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{ General.is94xForm(forms94xList, row.FormType) ? DateUtils.dateFormatter(new Date().toDateString(), 'MM/DD/YYYY') : DateUtils.dateFormatter(row.ScheduleDate, "MM/DD/YYYY")}</span>
		},
		{
			field: "actions",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Actions</Label>,
			renderLogic: (row, idx) => <div style={styles.gridActions}>
				{ ![FILE_STATUS.BLOCKED, FILE_STATUS.INQUEUE].includes(getFileStatus(row)) && 
					<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'View Form'} onClickCb={() => viewPDF(row)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button> 
				}
				<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Download Form'} onClickCb={() => downloadPDF(row)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DOWNLOAD_ICON} /></Button>
			</div>
		},
	]

	const viewPDF = (row) => {
		let rowFormLabelVariations = [row.FormType, row.FormType.replace("-", "")]
		const formId = formList.find(form => rowFormLabelVariations.includes(form.label) || rowFormLabelVariations.includes(form.label.replace("-", "")) )?.value ?? '';
		if(row?.FormType.toLowerCase() === FORM_TYPE.FORM_BOI.toLowerCase()){
			let formListingQueryObj = {
				[BOI_QUERY_PARAMS.REPORTING_COMPANY]: row.PayerId,
				[BOI_QUERY_PARAMS.STATUS]: getFileStatus(row)
			}
			const formListingQueryStr = General.convertObjToQueryString(formListingQueryObj)
			navigate(`/${MANAGE_BOI_ROUTES.BOI_REPORTING}?${formListingQueryStr}`);
		}else{
			switch(getFileStatus(row)) {
				default:
				case FILE_STATUS.NOT_SUBMITTED:
					let formListingQueryObj = {
						TaxYear: row.TaxYear,
						FormId: formId,
						PayerId: row.PayerId,
					}
					if(row?.IsCorrected){
						formListingQueryObj = {
							...formListingQueryObj,
							FormType: QUERY_PARAMS_VALUE.CORRECTED,
						}
					}
					const formListingQueryStr = General.convertObjToQueryString(formListingQueryObj)
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}?${formListingQueryStr}`);
					break;
				case FILE_STATUS.SUBMITTED: 
				case FILE_STATUS.IRS_ACCEPTED: 
				case FILE_STATUS.ONLYSTATESUBMITTED:
					formCategory.find( form => row.FormType.toLowerCase().includes(form.toLowerCase())) ? 
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.MANAGE}/${FORM_SECTION_ROUTES.FEDERALFORMS}?PayerId=${row.PayerId}&TaxYear=${row.TaxYear}&Category=944x`) 
						: 
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.MANAGE}/${FORM_SECTION_ROUTES.FEDERALFORMS}?PayerId=${row.PayerId}&TaxYear=${row.TaxYear}&Category=1099&FilterText=`);
					break; 
				case FILE_STATUS.RESUBMIT:
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.IRSSTATEREJECTED}?ReferenceId=${row.ReferenceId}`);
					break;
				case FILE_STATUS.REVIEW_APPROVED:
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}?Status=Approved&FormId=${formId}&TaxYear=${row.TaxYear}&PayerId=${row.PayerId}`);
					break;
				case FILE_STATUS.SUBMITTED_FOR_REVIEW:
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}?Status=Pending&FormId=${formId}&TaxYear=${row.TaxYear}&PayerId=${row.PayerId}`);
					break;
				case FILE_STATUS.REVIEW_REJECTED:
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}?Status=Rejected&FormId=${formId}&TaxYear=${row.TaxYear}&PayerId=${row.PayerId}`);
					break;
				case FILE_STATUS.RESUBMITTED_FOR_REVIEW:
					navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}?Status=ReSubmitted&FormId=${formId}&TaxYear=${row.TaxYear}&PayerId=${row.PayerId}`);
					break;
			}
		}
	}

	const downloadPDF = (row) => {
		const status = statusList.find(status => status.value !== null && status.value.includes(row.StatusId)).label

		switch (status) {
			case 'Submitted':
				setShowPopup(true);
				setSelectedRow(row)
				break;
			default:
				processDownload(row)
				break;
		}
	}

	const handleCancelDownload = () => {
		setShowPopup(false);
		setSelectedRow(null);
		setSelectedCopy(COPY_OPTIONS[2]);
	}

	useEffect(() => {
		General.downloadFileWithBase64AndName(exportFile)
	}, [exportFile])

	const processDownload = (row) => {
		dispatch(createPDF({
			payerName: row.Name,
			payerId: row.PayerId,
			referenceNo: row?.ReferenceId ?? null,
			partNumber: null,
			maskTin: maskTin,
			pdfCopy: selectedCopy.value,
			formName: row.FormType,
			taxYear: parseInt(row.TaxYear),
			sourcePage: "Dashboard",
			isCorrected: row.IsCorrected,
			mergeCopies: mergeCopies,
		}))
		setShowPopup(false);
		setSelectedRow(null);
		setSelectedCopy(COPY_OPTIONS[2]);
	}

	const handleInputChange = (e) => {
		switch (e.target.name) {
			case 'typeReference':
				if (e.target.value.length <= 10) {
					dispatch(setTypeReference(e.target.value));
				}
				break;
			case 'tin':
				dispatch(setTin(e.target.value))
				break;
		}
	}

	const handleRoleChange = (name, selectedOption) => {
		switch (name) {
			case 'status':
				dispatch(setSelectedStatus(selectedOption))
				break;
			case 'year':
				dispatch(setSelectedYear(selectedOption))
				break;
			case 'form':
				dispatch(setSelectedForm(selectedOption))
		}
	}

	const handleGetReportData = useDelayedAction((updateSkipToDefault = false, skip, rowsPerPage) => {
		if(!isNewUser && selectedForm?.label) {
			if(updateSkipToDefault){
				dispatch(setSkip(0))
			}
			dispatch(getReportData({
				params: {
					page: ((updateSkipToDefault ? 0 : skip) / rowsPerPage) + 1,
					pageSize: rowsPerPage,
					Statuses: selectedStatus?.value === undefined || selectedStatus?.value === '' ? [] : selectedStatus?.value,
					Year: selectedYear?.value,
					FormType: selectedForm?.label,
					Tin: tin,
					Ref: typeReference,
					UserID: 0
				}
			}))
		}
	})

	useEffect(() => {
		handleGetReportData(true, skip, rowsPerPage);
	}, [selectedYear, selectedForm, selectedStatus, tin, typeReference, isNewUser])

	useEffect(() => {
		const CancelToken = axios.CancelToken;
		const source = CancelToken.source();
		if(FEATURE_FLAG.NEW_HOMESCREEN_URGENT_ISSUES) {
			dispatch(getAccountStatus({accountStatusCancelToken: source}))
		}

		return () => {
			source.cancel();
		}
	}, [])

	useEffect(() => {
		if (isUserAuthenticated && !selectedYear?.value && backEndConfigSettings?.CURRENT_TAX_YEAR) {
			dispatch(getFilterData({currentTaxyear: backEndConfigSettings?.CURRENT_TAX_YEAR ?? null}))
		}
	}, [isUserAuthenticated, backEndConfigSettings?.CURRENT_TAX_YEAR])

	const CTA_LINKS = {
		createForm: { name: "createForm", link: "/forms/createnew" },
		addPayer: { name: "addPayer", link: "/payer/add" },
		addRecipient: { name: "addRecipient", link: "/recipient/add" },

	}


	const handleNavigation = (destination) => {
		switch (destination) {
			case CTA_LINKS.createForm.name:
				navigate(CTA_LINKS.createForm.link)
				break;
			case CTA_LINKS.addPayer.name:
				navigate(CTA_LINKS.addPayer.link)
				break;
			case CTA_LINKS.addRecipient.name:
				navigate(CTA_LINKS.addRecipient.link)
				break;
		}
	}

	useEffect(() => {
		if(!selectedYear?.value && isUserAuthenticated){	
			dispatch(checkIsNewUser())
		}
	}, [])

	useEffect(()=>{
		dispatch(setShowTestAccountWarningModal(true))
	},[])

	const handleExportExcelClick = () =>{
		dispatch(getDashboardExcelData())
	}

	return (
		<PageBody>
			<div style={styles.mainContainer}>
				<Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING, COMMON_LOADING_STATES.GENERAL_LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
					{ (!isNewUserLoading && isNewUser) &&
						<>
							<div style={styles.headerRow}>
								<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize24}>Thank you {signedInUser.FirstName}, for onboarding!</Label>
								<Label customStyles={styles.fontSize24}>How would you prefer to begin?</Label>
							</div>
							<div style={styles.quickActionsRow}>
								<div style={styles.quickAction}>
									<div style={styles.quickActionHeaderRow}>
										<Label weight={LABEL_WEIGHT[600]} customStyles={styles.fontSize24}>Create a Form?</Label>
										<p style={styles.fontSize16}>Get started with eFiling 1099 forms easily.</p>
										<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.createForm.name)}>
											<div style={styles.quickActionCTALabel}>Create Form</div>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.POINTER_ICON} />
										</div>
									</div>
									<div style={styles.quickActionBottomRow}>
										<div style={styles.quickActionCTA} onClick={() => navigate('/support')}>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.NEED_HELP_ICON} />
											<div>Need Help?</div>
										</div>
										<Icons familyName={'vec'} iconName={VEC_ICON_NAME.CREATE_FORM_VECTOR} />
									</div>
								</div>
								<ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_PAYERS}>
									<div style={styles.quickAction}>
										<div style={styles.quickActionHeaderRow}>
											<Label weight={LABEL_WEIGHT[600]} customStyles={styles.fontSize24}>Add a Payer?</Label>
											<p style={styles.fontSize16}>A payer is someone who pays benefits to other recipients.</p>
											<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.addPayer.name)}>
												<div style={styles.quickActionCTALabel}>Get Started</div>
												<Icons familyName={'vec'} iconName={VEC_ICON_NAME.POINTER_ICON} />
											</div>
										</div>
										<div style={styles.quickActionBottomRow}>
											<div style={styles.quickActionCTA} onClick={() => navigate('/support')}>
												<Icons familyName={'vec'} iconName={VEC_ICON_NAME.NEED_HELP_ICON} />
												<div>Need Help?</div>
											</div>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.ADD_PAYER_VECTOR} />
										</div>
									</div>
								</ShowForAllowedPermissionsOnly>
								<div style={styles.quickAction}>
									<div style={styles.quickActionHeaderRow}>
										<Label weight={LABEL_WEIGHT[600]} customStyles={styles.fontSize24}>Add a Recipient?</Label>
										<p style={styles.fontSize16}>A recipient receives benefits from the payers.</p>
										<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.addRecipient.name)}>
											<div style={styles.quickActionCTALabel}>Add Recipient</div>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.POINTER_ICON} />
										</div>
									</div>
									<div style={styles.quickActionBottomRow}>
										<div style={styles.quickActionCTA} onClick={() => navigate('/support')}>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.NEED_HELP_ICON} />
											<div>Need Help?</div>
										</div>
										<Icons familyName={'vec'} iconName={VEC_ICON_NAME.ADD_RECIPIENT_VECTOR} />
									</div>
								</div>
							</div>
						</>
					}

					{
						(!isNewUserLoading && !isNewUser) &&
						<>
							<div style={styles.headerRow}>
								{
									showGreetingHeader ?
									<>
										<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize24}>Hi {signedInUser.FirstName}! Happy to see you back here.</Label>
										<Label customStyles={styles.fontSize24}>What are you looking to do today?</Label>
									</>
									:
									<div style={styles.homeSectionAlternateGreetingsRow}>
										<Icons familyName={'vec'} iconName={VEC_ICON_NAME.USER_ICON} transformScale={0.4} color='#FFF' /><span>Invitations to 2 member users are still pending. Want to invite more member users?</span>
									</div>
								}
							</div>
							<div style={styles.miniCTARow}>
								<div style={styles.miniCTAInnerRow}>
									<div style={styles.miniCTA}>
										<Icons familyName={'vec'} iconName={VEC_ICON_NAME.CREATE_FORM_VECTOR_MINI} />
										<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.createForm.name)}>
											<div style={styles.quickActionCTALabel}>Create a Form?</div>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} />
										</div>
									</div>
								</div>
								<VerticalSeparator style={styles.fullHeight} />
								<ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_PAYERS}>
									<div style={styles.miniCTAInnerRow}>
										<div style={styles.miniCTA}>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.ADD_PAYER_VECTOR_MINI} />
											<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.addPayer.name)}>
												<div style={styles.quickActionCTALabel}>Add a Payer?</div>
												<Icons familyName={'vec'} iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} />
											</div>
										</div>
									</div>
									<VerticalSeparator style={styles.fullHeight} />
								</ShowForAllowedPermissionsOnly>
								<div style={styles.miniCTAInnerRow}>
									<div style={styles.miniCTA}>
										<Icons familyName={'vec'} iconName={VEC_ICON_NAME.ADD_RECIPIENT_VECTOR_MINI} />
										<div style={styles.quickActionCTA} onClick={() => handleNavigation(CTA_LINKS.addRecipient.name)}>
											<div style={styles.quickActionCTALabel}>Add a Recipient?</div>
											<Icons familyName={'vec'} iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} />
										</div>
									</div>
								</div>
								{
									FEATURE_FLAG.NEW_HOMESCREEN_URGENT_ISSUES && Object.keys(urgentIssues).length > 0 && Object.keys(urgentIssues).filter(key => urgentIssues[key] > 0).length ?
										<>
											<VerticalSeparator style={styles.fullHeight} />
											<MiniCTACarousel ctaArray={urgentIssues} />
										</>
										: null
								}
							</div>
						</>
					}
					{
						Object.keys(insights).length > 0 &&
						<div style={styles.insightsRow}>
							<div style={styles.insightsInnerRow}>
								<span>The following insights will help you ensure perfect filing this year</span>
								<div style={styles.insightsIconsSection}>
									{
										Object.keys(insights).map(key => 
											<>
												<div id={key} style={styles.positionRelative}>
													<Icons familyName={'vec'} iconName={getInsightIcon(key)} color={'#FFF'}/>
													<div style={styles.insightsBadge}>{insights[key].count}</div>
												</div>
												<TxTooltip id={key} text={getInsightsMessage(key, insights[key])} />
											</>
										)
									}
								</div>
							</div>
							<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}><strong>View All</strong> </Button>
						</div>
					}
					{ (!isNewUserLoading && !General.hasAccessToUserType(signedInUser.UserType, [USER_TYPE_MAPPING.ENTERPRISE_USER, ...USER_TYPE_MAPPING.MEMBER_USER])) &&
						<div style={styles.explorePlanSection}>
							<div style={styles.explorePlanLeftContainer}>
								<Icons familyName={'vec'} iconName={VEC_ICON_NAME.EXPLORE_PLAN_VECTOR} />
								<div style={styles.explorePlanLeftText}>
									<Label weight={LABEL_WEIGHT[700]} customStyles={styles.fontSize16}>Discover our premium features to get things done faster and manage a larger team!</Label>
									<div style={styles.explorePlanLeftSubText}>
										<Label>Integration Services</Label>
										<Label>|</Label>
										<Label>API Services</Label>
										<Label>|</Label>
										<Label>Notices</Label>
										<Label>|</Label>
										<Label>User Management</Label>
									</div>
								</div>
							</div>
							<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.explorePlanButton} onClickCb={() => setShowChangePlanPopup(true)}>Explore Plan</Button>
						</div>
					}


					<HorizontalSeparator />
				</Loadable>

				{ (!isNewUserLoading && !isNewUser) &&
					<>
						<Loadable currentState={loadingState.state} loadingStates={[COMMON_LOADING_STATES.FILTER_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
							<Label><span style={styles.red}>Note: </span>{"If you have filed form(s) directly to a State (not via the Combined Federal/State Filing program), you may need to file a Reconciliation form to accompany the State form(s). To file a Reconciliation form, go to Forms > File Reconciliation Form."}</Label>
							<div style={styles.filterRow}>
								<div style={styles.flexOne}>
									<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search by: </Label>
									<TextInput
										type={'text'}
										placeHolder={"Type payer TIN or Part of name or client ID"}
										name={'tin'}
										value={tin}
										onChangeCb={(e) => handleInputChange(e)}
									/>
								</div>
								{selectedStatus &&
									<div style={styles.flexOne}>
										<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Select Status: </Label>
										<SelectDropdown
											name="status"
											value={{ label: selectedStatus.label, value: selectedStatus.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => handleRoleChange(name, selectedOption)}
											options={statusList}
										/>
									</div>
								}
								{selectedYear &&
									<div style={styles.flexOne}>
										<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Select Year: </Label>
										<SelectDropdown
											name="year"
											value={{ label: selectedYear.label, value: selectedYear.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => handleRoleChange(name, selectedOption)}
											options={yearList}
										/>
									</div>
								}
								{selectedForm &&
									<div style={styles.flexOne}>
										<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Select Form: </Label>
										<SelectDropdown
											name="form"
											value={{ label: selectedForm.label, value: selectedForm.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => handleRoleChange(name, selectedOption)}
											options={formList}
										/>
									</div>
								}
								<div style={styles.flexOne}>
									<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search Type Reference Number: </Label>
									<TextInput
										type={'number'}
										placeHolder={"Type Reference Number"}
										name={'typeReference'}
										value={typeReference}
										onChangeCb={(e) => handleInputChange(e)}
									/>
								</div>
							</div>
							<div style={styles.exportToExcelButtonDiv}>
								<Button onClickCb={handleExportExcelClick} style={styles.exportToExcelButton}>
									<Icons familyName={'vec'} iconName={VEC_ICON_NAME.EXPORT_ICON} />
								  <span>Export To Excel</span>
								</Button>
							</div>
						</Loadable>

						<Loadable currentState={loadingState.state} loadingStates={[COMMON_LOADING_STATES.GRID_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
							<RichGrid
								data={reportData}
								columns={DASHBOARD_COLUMNS}
								extractRowKey={(row) => row.ApplicationUserLogId}
								paginationProps={{
									skip: skip,
									take: rowsPerPage,
									takeOptions: ROW_SELECTION_OPTIONS,
									onChangeTakeCb: (newTake) => {
										dispatch(setRowsPerPage(newTake));
										dispatch(setSkip(0));
										handleGetReportData(false, 0, newTake);
									},
									total: totalReport,
									onChange: (take, t) => {
										dispatch(setRowsPerPage(take));
										dispatch(setSkip(t));
										handleGetReportData(false, t, take);
									},
								}}
							/>
							<Label><b>Note: </b>The total amounts listed under the Amounts($) column above on this dashboard, are not a sum of wages or amounts only that were paid to vendors, but a total of every box an amount is entered in (excluding the State Boxes), in the form(s).</Label>
						</Loadable>
					</>
				}

				<Popup title={"View Print Form"} onCloseCb={() => { setShowPopup(false) }} isPopupOpen={showPopup} customPopupSyles={styles.customPopupStyle} childrenStyles={styles.padding}>
					<div style={styles.popupBody}>
						{COPY_OPTIONS.map(option =>{
							if(option?.isCheckBox){
								return <CheckboxWLabel containerCustomStyle={styles.checkBoxConatiner} labelCustomStyles={{ ...styles.checkBoxLabel, ...styles.fontSize16 }} label={option.label} checked={option.isChecked} onChangeCb={(e) => option.onChangeCb(e?.target?.checked)} />
							}else {
								return <RadioInput
								name={option.label}
								label={
									{ suffixLabel: option.label }
								}
								value={option.value}
								checked={option.value === selectedCopy.value}
								onChangeCb={(e) => setSelectedCopy(option)}
								/>
							}
						})}
					</div> 
					<div style={styles.actionsRow}>
						<Button onClickCb={() => processDownload(selectedRow)}>Save</Button>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={handleCancelDownload}>Cancel</Button>
					</div>
				</Popup>
			</div>
			{showChangePlanPopup && <ChangePlan showPopup={showChangePlanPopup} closePopup={() => setShowChangePlanPopup(false)} />}
			{FEATURE_FLAG.TEST_ACCOUNT_WARNING_POPUP ? <InformationPopup
				title={"Important Notice:"}
				bodyText={"Please be advised that this is a Staging website (pre - production site). Forms entered/submitted here will not be processed by the IRS, State, or SSA. For official 1099 form filing, kindly visit."}
				iconName={VEC_ICON_NAME.WARNING_ICON}
				isOpen={showTestAccountWarningModal}
				confirmationButtonProps={{
					onConfirmationCb: () => dispatch(setShowTestAccountWarningModal(false)),
					confirmationButtonText: "Ok",
					confirmationButtonStyles: {},
					confirmationButtonType: BUTTON_TYPE.PRIMARY,
				}}
				customBodyContainerStyle={styles.testAccountWarningBody}
				customBodyTextStyle={styles.testAccountWarningBodyText}
			>
				<Link style={styles.redirectToUrl} to={APP_PRODUCTION_URL} target="_blank">web.tax1099.com</Link>
			</InformationPopup> : null}
		</PageBody>
	)
}